import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap5';

import Template from './Template';

const getVariantByIndex = (index) => {
  const variants = ['primary', 'secondary', 'tertiary-400', 'tertiary-1000'];
  const position = index % variants.length;
  return variants[position];
};

export default function Templates({ templates, policyEnabled }) {
  return (
    <Row>
      {templates && templates.map((template, index) => (
        <Template
          key={template.id}
          template={template}
          variant={getVariantByIndex(index)}
          policyEnabled={policyEnabled}
        />
      ))}
    </Row>
  );
}

Templates.propTypes = {
  templates: PropTypes.arrayOf(PropTypes.object),
  policyEnabled: PropTypes.bool,
};

Templates.defaultProps = {
  templates: null,
  policyEnabled: true,
};
